<h3 mat-dialog-title>Sklonuj publikację</h3>
<mat-dialog-content class="input-name">
    <mat-form-field
        appearance="outline"
        class="full-width"
    >
        <mat-label>Nazwa nowej publikacji</mat-label>
        <input
            matInput
            [formControl]="nameControl"
            (keydown.enter)="onSave()"
            autocomplete="off"
        />
        @if (nameControl.hasError("required")) {
            <mat-error>Nazwa jest wymagana</mat-error>
        }
        @if (nameControl.hasError("minlength")) {
            <mat-error>Nazwa musi mieć co najmniej 3 znaki</mat-error>
        }
        @if (nameControl.hasError("nameTaken")) {
            <mat-error>Publikacja o tej nazwie już istnieje.</mat-error>
        }
    </mat-form-field>

    @if (saveError()) {
        <p class="save-error">{{ saveError() }}</p>
    }
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button
        mat-button
        [disabled]="isSaving()"
        (click)="onCancel()"
    >
        Anuluj
    </button>
    <button
        mat-flat-button
        color="primary"
        [disabled]="nameControl.invalid || isSaving()"
        (click)="onSave()"
    >
        @if (isSaving()) {
            <mat-progress-spinner
                diameter="20"
                mode="indeterminate"
            />
        } @else {
            Zapisz kopię
        }
    </button>
</mat-dialog-actions>
